import React, { useRef, useState } from "react";
import html2canvas from "html2canvas";
import logo from "../../../assets/Appan Courier Logo.png";
import CrossIcon from "../../../assets/Icons/cross_svg.svg";
import LeftCircle from "../../../assets/Icons/Left circle B.png";
import RightCircle from "../../../assets/Icons/Right circle A.png";
import { formatDateMonth } from "../../../helpers/DateHelpers";
import jsPDF from "jspdf";

const PaymentReceipt = ({handleClose, data}) => {
  const receiptRef = useRef(null);
  const [isDownloading, setIsDownloading] = useState(false);

  const receiptData = {
    orderId: data?.referenceId || data?.orderId || "N/A",
    transactionId: data?.transactionId || "N/A",
    rrn: data?.rrn || "N/A",
    amount:
      data?.amountE ||
      data?.amount ||
      data?.gatewayAmount ||
      0,
     paymentMethod:
      data?.paymentMode ||
      data?.paymentMethod ||
      "N/A",
    currency: data?.currency || "INR",
    lmbpName:
      data?.walletUserName ||
      data?.lmbpName ||
      "N/A",
    terminalId:
      data?.terminalId || "N/A",
    vpId:
      data?.vpaId ||
      "N/A",
    createdDate:
      data?.transactionDateTimeE ||
      data?.createdDate ||
      "N/A",
    updatedDate:
      data?.updatedDate || "N/A",
    status:
      data?.status ||
      data?.responseMessage ||
      "UNKNOWN",
  };

  const normalizeStatus = (status) => {
    if (!status) return "UNKNOWN";
  
    const s = status.toUpperCase();
  
    if (s === "APPROVED" || s === "SUCCESS") return "SUCCESS";
    if (s === "FAILED") return "FAILED";
    if (s === "CANCELLED" || s === "CANCELED") return "CANCELLED";
    if (s === "TIMEOUT") return "TIMEOUT";
  
    return "UNKNOWN";
  };

  const getStatusUI = (status) => {
  const normalized = normalizeStatus(status);

  switch (normalized) {
      case "SUCCESS":
        return {
          text: "Transaction Successful",
          color: "text-green-600",
          bg: "bg-green-100",
        };
  
      case "FAILED":
        return {
          text: "Transaction Failed",
          color: "text-red-600",
          bg: "bg-red-100",
        };
  
      case "CANCELLED":
        return {
          text: "Transaction Cancelled",
          color: "text-orange-600",
          bg: "bg-orange-100",
        };
  
      case "TIMEOUT":
        return {
          text: "Transaction Timeout",
          color: "text-yellow-600",
          bg: "bg-yellow-100",
        };
  
      default:
        return {
          text: "Transaction Status Unknown",
          color: "text-gray-600",
          bg: "bg-gray-100",
        };
    }
  };

  const statusUI = getStatusUI(receiptData.status);

const downloadReceipt = async () => {
  if (!receiptRef.current) return;

  const actions = document.getElementById("receipt-actions");

  try {
    setIsDownloading(true);

    // Hide buttons before capture
    if (actions) actions.style.display = "none";

    const canvas = await html2canvas(receiptRef.current, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const margin = 10;

    let imgWidth = pageWidth - margin * 2;
    let imgHeight =
      (canvas.height * imgWidth) / canvas.width;

    // 🔥 IMPORTANT: Prevent bottom cut
    if (imgHeight > pageHeight - margin * 2) {
      imgHeight = pageHeight - margin * 2;
      imgWidth =
        (canvas.width * imgHeight) / canvas.height;
    }

    const x = (pageWidth - imgWidth) / 2;
    const y = margin;

    pdf.addImage(
      imgData,
      "PNG",
      x,
      y,
      imgWidth,
      imgHeight
    );

    pdf.save(`Receipt-${receiptData.orderId}.pdf`);

  } catch (error) {
    console.error("PDF download failed", error);
  } finally {
    if (actions) actions.style.display = "flex";
    setIsDownloading(false);
  }
};

  return (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
      {/* Receipt */}
      <div
        ref={receiptRef}
        className="w-full max-w-[600px] bg-white rounded-xl shadow-lg overflow-hidden"
      >
        {/* Header */}
        <div className="text-center p-3 border-b-4 border-orange-500">
          <img
            src={logo}
            alt="Logo"
            className="h-[85px] mx-auto"
          />

          <div className="text-xs text-gray-500">
            SAFE & FAST
          </div>

        </div>

        {/* Content */}
        <div className="px-5 py-1">

          <div className="text-center text-lg font-bold mb-2">
            Payment Receipt
          </div>

          <table className="w-full border-collapse">

            <tbody>

              {Object.entries({
                "Order ID": receiptData.orderId,
                "Transaction ID": receiptData.transactionId,
                RRN: receiptData.rrn,
                Amount:`₹ ${Number(receiptData?.amount || 0).toFixed(2)}`,
                "Payment Method": receiptData.paymentMethod,
                Currency: receiptData.currency,
                "LMBP Name": receiptData.lmbpName,
                "Terminal ID": receiptData.terminalId,
                "VP ID": receiptData.vpId,
                "Created Date": formatDateMonth(receiptData.createdDate),
                // "Updated Date": receiptData.updatedDate,
                Status: receiptData.status,
              }).map(([key, value]) => (
                <tr key={key} className="border-b">
                  <td className="py-2 font-semibold text-gray-600 w-[45%]">
                    {key}
                  </td>
                  <td className="py-2 text-sm">
                    {value}
                  </td>
                </tr>
              ))}

            </tbody>

          </table>

          {/* Status */}
          <div 
           className={`text-center pt-3 pb-1 font-bold text-base ${statusUI.color}`}
          >
            {statusUI.text}
          </div>

        </div>

        {/* Footer */}
        <div className="text-center text-xs px-4 pb-1 text-gray-400">
          Thank you for choosing Appan Courier
        </div>

        {/* Download Button */}
        <div 
          id="receipt-actions"
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "12px",
            paddingBottom: "0px",
            gap: "16px",
          }}
        >
          <button
            onClick={handleClose}
            // className="btn btn-back !rounded-lg"
            className="w-[133px] bg-blue-600 text-white py-2 h-[39px] rounded-lg font-medium hover:bg-blue-700 shadow-md transition"
          >
            Close
          </button>

        <button
          onClick={downloadReceipt}
          className="mb-4 btn addUser"
          disabled={isDownloading}
        >
          {isDownloading ? "Downloading..." : "Download Receipt"}
        </button>
        </div>

      </div>
    </div>
  );
};

export default PaymentReceipt;